import { apiFetch } from '@/lib/api-client'

export class TtsError extends Error {
  constructor(
    message: string,
    public readonly status?: number
  ) {
    super(message)
    this.name = 'TtsError'
  }
}

/** 后端是否已启用并配置语音朗读；失败按不可用处理，不影响聊天。 */
export async function fetchTtsAvailable(): Promise<boolean> {
  try {
    const response = await apiFetch('/tts/status', { cache: 'no-store' })
    if (!response.ok) return false
    const data = (await response.json()) as { available?: unknown }
    return data.available === true
  } catch {
    return false
  }
}

/** 把一段回复（可含 Markdown，服务端会转纯文本）合成为 MP3。 */
export async function synthesizeSpeech(text: string, signal?: AbortSignal): Promise<Blob> {
  const response = await apiFetch('/tts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text }),
    signal,
  })
  if (!response.ok) throw new TtsError('Speech synthesis failed', response.status)
  const audio = await response.blob()
  if (audio.size === 0) throw new TtsError('Empty audio')
  return audio
}
